import React from 'react';
import { useParams } from 'react-router-dom';
import Container from 'src/components/shared/Container';
import Seo from 'src/components/Seo';
import seoConfig from '../../seo.json';
import UserProfile from 'src/components/profile/UserProfile';

const Profile = () => {
	const { userHandler } = useParams();
	const seoInfo = seoConfig['profile'];

	return (
		<>
			<Seo title={seoInfo.title} description={seoInfo.description} />
			<div className="">
				<UserProfile forceMobileView={false} userHandler={String(userHandler)} />
			</div>
		</>
	);
};

export default Profile;
